import {pxToRem} from '../../../../utills/pxToRem'
import sizes from '../../../../theme/foundations/sizes'

export const homeTopBrandsContainerStyles = {
    margin: `${pxToRem(30)} 0`,
    color: 'black',
    fontFamily: 'Montserrat',
    alignItems: 'center',
    [`@media (min-width: ${sizes.container.md})`]: {
        margin: `${pxToRem(40)} 0`
    },

    h2: {
        textAlign: 'center',
        fontSize: pxToRem(18),
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        letterSpacing: pxToRem(2.7),
        textTransform: 'uppercase',
        marginBottom: pxToRem(20),

        [`@media (min-width: ${sizes.container.md})`]: {
            fontSize: pxToRem(22),
            letterSpacing: pxToRem(3.3)
        },

        [`@media (min-width: ${sizes.container.xl})`]: {
            margin: `${pxToRem(40)} 0 ${pxToRem(25)}`
        }
    },

    '.spring-styles-slider': {
        marginLeft: pxToRem(10),

        [`@media (min-width: ${sizes.container.md})`]: {
            margin: `0 0 0 ${pxToRem(30)}`
        },

        '.slick-list': {
            boxSizing: 'border-box',
            paddingLeft: '0 !important'
        },

        '.slick-slide': {
            paddingRight: pxToRem(15),
            opacity: '0.6',
            transition: 'opacity 0.5s ease',
            [`@media (min-width: ${sizes.container.md})`]: {
                padding: `0 ${pxToRem(10)}`
            },

            '&.slick-active': {
                opacity: 1
            }
        },

        '.slide-item': {
            transition: 'transform 0.5s ease',
            '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: `0 ${pxToRem(10)} ${pxToRem(20)} var(--chakra-colors-blackAlpha-400)`,

                '.slide-content > h3': {
                    color: 'cav_red'
                }
            },

            img: {
                width: '100%'
            },

            a: {
                textDecoration: 'none'
            }
        },

        '.slick-arrow': {
            width: pxToRem(40),
            height: pxToRem(40),
            background: 'cav_light_black_aqua',
            color: 'white',
            borderRadius: '50%',
            zIndex: 2,

            '&:hover': {
                background: 'black',
                color: 'white'
            }
        },

        '.slick-next': {
            right: pxToRem(30),

            [`@media (min-width: ${sizes.container.lg})`]: {
                right: pxToRem(45)
            }
        },

        '.slide-content > h3': {
            padding: `${pxToRem(10)} ${pxToRem(10)} 0`,
            fontSize: pxToRem(12),
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: pxToRem(0.96),
            textTransform: 'uppercase',
            textAlign: 'center',
            color: 'black',

            [`@media (min-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(14),
                letterSpacing: pxToRem(2.1),
                padding: `${pxToRem(20)} ${pxToRem(10)}`
            }
        }
    }
}
